module.exports = __webpack_public_path__ + "img/no-asset-build-up.0f0584d2.svg";